var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tabs',[_c('TabPane',{attrs:{"label":"动态发布"}},[_c('NewsRelease')],1),_c('TabPane',{attrs:{"label":"预警精灵"}},[_c('WarningSpirit')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }